import Section from '../Section/Section';
import Container from '../Container/Container';
import Form from '../Form/Form';
import { getPhotos } from '../../services/photos';
import type { Photo } from '../../types/photo';
import { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import PhotosGallery from '../PhotosGallery/PhotosGallery';
import Loader from '../Loader/Loader';
import Text from '../Text/Text';
import Modal from '../Modal/Modal';

export default function App() {
  const [photos, setPhotos] = useState<Photo[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState<Photo | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlerRequest = async (value: string) => {
    try {
      setIsLoading(true);
      const data = await getPhotos(value);
      if (data.length > 0) {
        setPhotos(data);
      } else {
        toast.error('Bad request!');
      }
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const openModal = (photo: Photo) => {
    setCurrentPhoto(photo);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setCurrentPhoto(null);
    setIsModalOpen(false);
  };

  return (
    <>
      <Section>
        <Container>
          {isLoading && <Loader />}
          {isError && (
            <Text>
              <p>Server request Error!</p>
            </Text>
          )}
          <Toaster />
          <Form onSubmit={handlerRequest} />
          {photos.length > 0 && (
            <PhotosGallery photos={photos} openModal={openModal} />
          )}
          {isModalOpen && currentPhoto && (
            <Modal onClose={closeModal}>
              <img src={currentPhoto.src.original} alt={currentPhoto.alt} />
            </Modal>
          )}
        </Container>
      </Section>
    </>
  );
}
